// extracted by css-extract-rspack-plugin
export default {"wrapper":"DySfF","wrapper_full":"IMEiF","wrapperFull":"IMEiF","wrapper_embedded":"OqSeG","wrapperEmbedded":"OqSeG","desktop":"M9SKX"};